var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [
      _vm.f.IsRequired
        ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.f.Name) + "\n    "),
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value",
        },
      ],
      staticClass: "form-control",
      attrs: {
        type: "date",
        placeholder: "Date...",
        title: "Please enter date",
        required: _vm.f.IsRequired === true,
        readonly: _vm.f.IsReadonly === true,
        min: _vm.minDate,
        max: _vm.maxDate,
      },
      domProps: { value: _vm.value },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.value = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))]),
    _vm._v(" "),
    _vm.f.Description
      ? _c("small", { staticClass: "form-text text-muted" }, [
          _vm._v(_vm._s(_vm.f.Description)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }